import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../components/Modal';
import ModalHeader from '../../components/ModalHeader';
import { getButtonByType } from '../../../components/Buttons';
import ModalButtons from '../../components/ModalButtons';

const ConfirmationModal = ({ onClose, theme, showModal, title, content, buttons }) => (
    <Modal
        open={ showModal }
        onClose={ onClose }
        theme={ theme }
    >
        <ModalHeader className={ theme.header } title={ title } />
        <div className={ theme.confirmationModal }>
            { content }
        </div>
        <ModalButtons theme={ theme }>
            { buttons.map(({ type, onClick, to, text }, index) => {
                const ButtonComponent = getButtonByType(type);

                return (
                    <ButtonComponent
                        key={ index } // eslint-disable-line react/no-array-index-key
                        onClick={ onClick }
                        to={ to }
                        text={ text }
                    />
                );
            })}
        </ModalButtons>
    </Modal>
);

ConfirmationModal.propTypes = {
    onClose: PropTypes.func,
    theme: PropTypes.shape({}),
    showModal: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        to: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        type: PropTypes.string.isRequired,
    })),
};

export default ConfirmationModal;
